const actions = {
  SET_ADD_LISTING_DATA: "SET_ADD_LISTING_DATA",
  SET_CATEGORY_FIELDS: "SET_CATEGORY_FIELDS",
  RESET_LISTING_DATA: "RESET_LISTING_DATA",
  CLEAR_ADD_LISTING_DATA: "CLEAR_ADD_LISTING_DATA",
  setAddListingData: (payload) => {
    return {
      type: actions.SET_ADD_LISTING_DATA,
      payload,
    };
  },
  setCategoryFields: (payload) => {
    return {
      type: actions.SET_CATEGORY_FIELDS,
      payload,
    };
  },
  resetListingData: (payload) => {
    return {
      type: actions.RESET_LISTING_DATA,
      payload,
    };
  },
  clearAddListingData: () => {
    return {
      type: actions.CLEAR_ADD_LISTING_DATA,
    };
  },
};

export default actions;
